import { ChatMessageModel, MessageStatusModel } from '@klant/conversational-connector/models/ChatMessage.model';
import { TypeModel } from '@klant/conversational-connector/models/Type.model';

import { inject, Injectable } from '@angular/core';

import { ConversationalChatStore } from '../../../../signal-stores/conversational-chat-store/conversational-chat.store';
import { ConversationalChatVisibility } from '../../klant-conversational-connector.model';
import { WebsocketService } from '../wsservice/websocket.service';

@Injectable({ providedIn: 'root' })
export class UnreadMessageService {
    private readonly conversationalChatStore = inject(ConversationalChatStore);
    private readonly webSocketService = inject(WebsocketService);

    public markMessagesAsRead(messages: ChatMessageModel[]): void {
        const receivedMessages = messages.filter((message) => this.shouldBeMarkedAsRead(message));

        const isChatMinimized = this.conversationalChatStore.chatVisibility() === ConversationalChatVisibility.MINIMIZED;
        if (isChatMinimized) {
            this.conversationalChatStore.addUnreadMessages(receivedMessages);
            return;
        }

        this.conversationalChatStore.clearUnreadMessages();
        this.webSocketService.markMessagesRead(receivedMessages);
    }

    private shouldBeMarkedAsRead(message: ChatMessageModel): boolean {
        const isOfCorrectMessageType = message.type === TypeModel.PLAIN_TEXT_MESSAGE || message.type === TypeModel.CHOICE_PROMPT_MESSAGE;
        const hasUpdatableStatus = message.messageStatus === MessageStatusModel.RECEIVED;

        return isOfCorrectMessageType && hasUpdatableStatus;
    }
}
